<template>
  <div class="home">
     <!--    轮播图-->
    <carousel-page></carousel-page>
<!--    内容区域-->
    <content-page v-if="$homePageInfo.dataSourceType!=='XMHQ'" ></content-page>
    <content-page1></content-page1>
    <content-page2></content-page2>
    <content-page3></content-page3>
    <contact-footer></contact-footer>
  </div>
</template>
<script>
// import NavBar from "@/view/navBar.vue";

import CarouselPage from "@/view/carousel.vue";
import ContentPage from "@/view/homeComponents/content.vue";
import ContentPage1 from "@/view/homeComponents/content1.vue";
import ContentPage2 from "@/view/homeComponents/content2.vue";
import ContentPage3 from "@/view/homeComponents/content3.vue";
import ContactFooter from "@/view/homeComponents/banner.vue";

// import { getHomePageInfo } from "@/api/home"
export default {
  name: 'HomePage',
  components: {ContactFooter, ContentPage3, ContentPage2, ContentPage1, ContentPage, CarouselPage},
  data(){
	  return{
		  homePageInfo:[],
          carouselImages:'',
          platName1:'',
          merList:[],
          platName2:'',
          middleBanner:'',
	  }
  },
  created(){  
  },
  methods:{
  }
}
</script>